class FIFOAsyncQueue {
  private queue: (() => Promise<void>)[] = [];
  private isProcessing = false;

  constructor() {
    console.log('FIFOAsyncQueue initialized!');
  }

  enqueue(task: () => Promise<void>) {
    this.queue.push(task);
    this.processQueue();
  }

  private async processQueue() {
    if (this.isProcessing || this.queue.length === 0) return;

    this.isProcessing = true;
    const task = this.queue.shift();

    try {
      if (task) await task();
    } catch (err) {
      console.error('Queue task failed:', err);
    }

    this.isProcessing = false;
    this.processQueue();
  }

  length() {
    return this.queue.length;
  }
}

export default FIFOAsyncQueue;
